import { API } from "../calendar/calendarUtils";

export { apiCall, fmtDate, euro } from "../calendar/calendarUtils";

export const MONTHS = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

export const STATES = {
  entwurf: { label: "Entwurf", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/40" },
  ausgestellt: { label: "Ausgestellt", cls: "bg-sky-500/15 text-sky-300 border-sky-500/40" },
  offen: { label: "Offen", cls: "bg-yellow-400/15 text-yellow-300 border-yellow-400/40" },
  teilweise: { label: "Teilweise bezahlt", cls: "bg-orange-500/15 text-orange-300 border-orange-500/40" },
  bezahlt: { label: "Bezahlt", cls: "bg-green-500/15 text-green-300 border-green-500/40" },
  ueberfaellig: { label: "Überfällig", cls: "bg-red-500/15 text-red-300 border-red-500/50" },
  storniert: { label: "Storniert", cls: "bg-red-900/20 text-red-400 border-red-800/50" },
  korrigiert: { label: "Korrigiert", cls: "bg-purple-500/10 text-purple-300 border-purple-500/40" },
  erstattet: { label: "Erstattet", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/40" },
  storno: { label: "Stornorechnung", cls: "bg-red-900/20 text-red-300 border-red-800/50" },
};

export const FILTER_STATES = [["", "Alle Status"], ["entwurf", "Entwurf"], ["ausgestellt", "Ausgestellt (alle)"], ["offen", "Offen"], ["teilweise", "Teilweise bezahlt"],
  ["bezahlt", "Bezahlt"], ["ueberfaellig", "Überfällig"], ["storniert", "Storniert / Korrigiert"]];

export const BASES = [["invoice", "Rechnungsdatum"], ["service", "Leistungsdatum"], ["payment", "Zahlungsdatum"]];

export const PAY_METHODS = [["bank_transfer", "Überweisung"], ["paypal", "PayPal"], ["cash", "Bar"], ["other", "Sonstige"]];
const PAY_LABELS = { ...Object.fromEntries(PAY_METHODS), credit: "Guthaben", training_card: "Trainingskarte", card: "Karte" };
export const payLabel = (m) => PAY_LABELS[m] || m || "–";

export const StateBadge = ({ state, testId }) => {
  const s = STATES[state] || STATES.offen;
  return <span className={`inline-block text-[11px] px-2 py-0.5 border whitespace-nowrap ${s.cls}`} data-testid={testId}>{s.label}</span>;
};

export const Sel = ({ value, onChange, options, testId, className = "" }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className={`h-9 px-2 bg-[#1A1A1A] border border-white/10 text-white text-sm ${className}`} data-testid={testId}>
    {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);

// Authenticated binary download / open (no public URLs)
export async function fetchBlob(token, path, filename, open = false) {
  const res = await fetch(`${API}${path}`, { headers: { "X-Admin-Token": token } });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    if (res.status === 401) window.dispatchEvent(new CustomEvent("admin-auth-expired", { detail: d?.detail }));
    throw new Error(typeof d.detail === "string" ? d.detail : "Download fehlgeschlagen");
  }
  const url = URL.createObjectURL(await res.blob());
  if (open) window.open(url, "_blank");
  else { const a = document.createElement("a"); a.href = url; a.download = filename; a.click(); }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export const yearOptions = (years) => {
  const now = new Date().getFullYear();
  return [...new Set([now, ...(years || [])])].sort((a, b) => b - a).map((y) => [String(y), String(y)]);
};
